import styled from "styled-components";
import { Layout, Menu } from 'antd';

const { Header, Sider, Content } = Layout;

export const UserAvatorContainer = styled("div")`
    padding: 5px;
    margin: 5px;
    background: rgba(255, 255, 255, 0.3);
    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
`;

export const UserAvatorTitle = styled("p")`
  font-size: 15px;
  font-weight:800;
  color: white;
  height:auto;
`;

export const UserAvatorRule = styled("p")`
  font-size: 11px;
  font-weight:300;
  color: white;
`;

export const CustomLayout = styled(Layout)`
    background: #fff;
`;

export const CustomHeader = styled(Header)`
    background-color:#4F9BD4;
    padding: 0;
`;

export const CustomContentSection = styled(Content)`
    background: #f1f2f2;
    min-height: 280;  
`;

export const TriggerContainer = styled("div")`
    padding: 0 24px;
    font-size: 18px;
    line-height: 64px;
    cursor: pointer;
    transition: color 0.3s;
    color: white;

  &:hover{
    color: black;
  }
`;

export const WelcomeTitle = styled("p")`
  font-size: 18px;
  font-weight:500;
  color: white;
  text-align:right;
  margin-right:10px;
  margin-top:15px;
`;

export const CompanyLogoContainer = styled("div")`
  display:flex;
  justify-content: right;
  margin-top:10px;
  margin-right:10px;
`;


export const Right = styled("p")`
  font-size: 12px;
  font-weight:600;
  text-transform: capitalize;
  color: #000;
  text-align:center;
  font-family:"arial";

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;